var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSoftwaredev = function SvgSoftwaredev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E53E3E",
    clipPath: "url(#softwaredev_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    opacity: 0.1,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h12c.368 0 .666.299.666.667v10.666A.667.667 0 0 1 22 22H10a.667.667 0 0 1-.667-.667V10.667c0-.368.298-.667.667-.667Zm6 8v1.333h4V18h-4Zm-2.39-2-1.886 1.886.942.942L15.495 16l-2.829-2.828-.943.942L13.61 16Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "softwaredev_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgSoftwaredev;